<template>
  <v-card width="375" flat class="payment-result mx-auto" >
    
    <!-- <CheckMark/> -->
    <img src="@/assets/checkmark-circle-outline.svg" class="checkmark"/>

    <RecapSDD v-if="params.methodTypeId === 1" :params="params"/>
    <RecapSDDB2B v-else-if="params.methodTypeId === 6" :params="params" v-model="canContinue"/>

    <v-card-title v-else class="resultTitle justify-center">
      {{ $t('payment_success') }}
    </v-card-title>
    <confirm-button 
      v-if="this.isCard(params.methodTypeId)" 
      class="icon-button mb-12"
      @click="close">
      {{$t('ReturnIn')}} {{closeSecs}}s
      <img class="button-icon" src="@/assets/arrow-forward-outline.svg"/>
    </confirm-button>
    <confirm-button v-else
      class="icon-button mt-8 mb-12"
      @click="close"
      :disabled="params.methodTypeId === 6 && !canContinue">
        {{$t('continue')}}
        <img class="button-icon" src="@/assets/arrow-forward-outline.svg"/>
    </confirm-button>
  </v-card>
</template>

<script>
import { VCard, VCardTitle} from 'vuetify/lib'
import RequestHandler from '@/views/payment//mixins'
import RecapSDD from './RecapSDD'
import RecapSDDB2B from './RecapSDDB2B'
import valueMappings from '@/mixins/valueMappings'
import postMessageMixin from '@/mixins/postMessageMixin'
import ConfirmButton from '@/components/ConfirmButton'

export default {
  name: 'PaymentResult',
  components: { VCard, VCardTitle, RecapSDD, RecapSDDB2B, ConfirmButton },
  mixins: [RequestHandler, valueMappings, postMessageMixin],
  props: {
    params: {
      type: Object,
      default: () => ({})
    },
    origin: {
      type: String,
      default: ''
    }
  },
  created () {
    this.$emit('stopLoader')
  },
  mounted () {
    this.postMessageToParent({ messageType: 'successDetails', resultCode: 0, redirectUrl: this.params.redirectUrl }, this.params, this.origin)
    if (this.isCard(this.params.methodTypeId)) {
      let count = this.closeSecs+1
      let timer = setInterval(() => {
        count--
        if (count === 0) {
          clearInterval(timer)
          this.closeSecs = 0
          this.close()
        }
        else this.closeSecs = count
      }, 1000)
    }
  }, 
  methods: {
    close: function () {
      this.postMessageToParent({ messageType: 'success', resultCode: 0, redirectUrl: this.params.redirectUrl }, this.params, this.origin)
    }
  },
  data() {
    return {
      canContinue: true,
      closeSecs: 5
    }
  },
}
</script>